import {isInteger} from "lodash";

const template = `

	<strong ng-if="$ctrl.state !== null">
		<span ng-bind="'BOOKING_LIMIT' | translate"></span>
		<span ng-bind="$ctrl.$getState().value" ng-class="$ctrl.$getState().class"></span>
	</strong>

`;

class controller {
	constructor($bookings, $companies, $auth, $translates, $rootScope, $timeout) {
		"ngInject";

		this.$bookings    = $bookings;
		this.$companies   = $companies;
		this.$auth        = $auth;
		this.$translates  = $translates;
		this.$rootScope   = $rootScope;
		this.$timeout     = $timeout;

		this.state = null;

		$rootScope.$on('bookingLimitComponentUpdate', (e, payload) =>
			$rootScope.$apply(() => this.state = payload.payload.limit_left)
		);

		$rootScope.$on('bookingLimitComponentUpdateValue', (e, payload) => this.$updateState(payload));

	}

	$onInit() {
		this.$auth.company$ && this.$auth.company$
			.then(()=> {
				this.$companies.activeGet(this.$auth.company.uris.BookingsLimitLeft)
					.then(response => this.state = isInteger(response.limit_left) ? parseInt(response.limit_left) : null);
			});
	}

	$getState() {
		return {
			"class": this.state > 0 ? "success" : "danger",
			"value": `${this.state} PLN`
		}
	}


	$updateState(state){

		if(this.state === null){
			return false;
		}

		const {actual_booking_value} = state;

		let new_state;

		switch(state.method){
			case "create":
				new_state = this.state - actual_booking_value;
				break;
			case "update":
				new_state = this.state + actual_booking_value;
				break;
		}

		this.$timeout(() => this.$rootScope.$apply(() => this.state = new_state), 0);

	}

}

export const bookingLimitComponent = {template, controller};


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-limit/booking-limit.component.js
 **/